module.exports = __webpack_public_path__ + "static/media/phone.590a9d44.svg";